import { supabase } from '../../api/supabase'

export interface BoxtraxSyncLog {
  id: string
  jobId: string
  endpoint: string
  requestJson: unknown
  responseJson: unknown | null
  httpStatus: number | null
  errorMsg: string | null
  initiatedBy: string | null
  // KI26034 P0: written 'pending' immediately after the BoxTop fetch
  // returns (before any validation), then updated to 'success' / 'error' /
  // 'partial' (BoxTop created the job but no reference field was found) --
  // so every attempt shows up here regardless of outcome.
  status: string
  createdAt: string
}

interface SyncLogRow {
  id: string
  job_id: string
  endpoint: string
  request_json: unknown
  response_json: unknown | null
  http_status: number | null
  error_msg: string | null
  initiated_by: string | null
  status: string
  created_at: string
}

function fromRow(row: SyncLogRow): BoxtraxSyncLog {
  return {
    id: row.id,
    jobId: row.job_id,
    endpoint: row.endpoint,
    requestJson: row.request_json,
    responseJson: row.response_json,
    httpStatus: row.http_status,
    errorMsg: row.error_msg,
    initiatedBy: row.initiated_by,
    status: row.status,
    createdAt: row.created_at,
  }
}

export async function fetchBoxtraxSyncLogs(jobId: string): Promise<BoxtraxSyncLog[]> {
  const { data, error } = await supabase
    .from('boxtrax_sync_logs')
    .select('*')
    .eq('job_id', jobId)
    .order('created_at', { ascending: false })

  if (error) throw new Error(`Failed to fetch BoxTop sync history: ${error.message}`)
  return ((data ?? []) as SyncLogRow[]).map(fromRow)
}
